import { render, staticRenderFns } from "./RequestWorkflow.vue?vue&type=template&id=436535c1&scoped=true"
import script from "./RequestWorkflow.vue?vue&type=script&lang=js"
export * from "./RequestWorkflow.vue?vue&type=script&lang=js"
import style0 from "./RequestWorkflow.vue?vue&type=style&index=0&id=436535c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436535c1",
  null
  
)

export default component.exports